import {
    CREATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS,
    DELETE_POINT_OF_INTEREST_SUCCESS,
    FETCH_POINTS_OF_INTEREST,
    FETCH_POINTS_OF_INTEREST_FAILURE,
    FETCH_POINTS_OF_INTEREST_SUCCESS,
    FETCH_POINT_OF_INTEREST,
    FETCH_POINT_OF_INTEREST_LOCALISATION,
    FETCH_POINT_OF_INTEREST_LOCALISATION_SUCCESS,
    FETCH_POINT_OF_INTEREST_SUCCESS,
    POINTS_OF_INTEREST_LIST_FILTER_UPDATE,
    POINTS_OF_INTEREST_LIST_FILTER_CATEGORY,
    POINTS_OF_INTEREST_LIST_PAGE,
    POINTS_OF_INTEREST_LIST_SORT,
    SORT_ASC,
    UPDATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS,
} from 'store/actions/types';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';

const initialState = {
    data: {},
    field: 'name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    localisation: {},
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_POINT_OF_INTEREST:
        case FETCH_POINTS_OF_INTEREST:
        case FETCH_POINT_OF_INTEREST_LOCALISATION:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_POINTS_OF_INTEREST_FAILURE:
            return Object.assign({}, state, {
                loading: false,
            });

        case FETCH_POINTS_OF_INTEREST_SUCCESS:
            // Converts the Array of results to an Object based on the id.
            const convertResultsToData = utils.mapToObject(action.payload.results, (value) => {
                return value.id;
            });

            const newIds = action.payload.results.map(function (result) {
                return result.id;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, convertResultsToData),
                ids: newIds,
                loading: false,
                offset: action.payload.offset,
                size: action.payload.size,
                total: parseInt(action.payload.total, 10),
            });

        case FETCH_POINT_OF_INTEREST_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: action.response,
                }),
                ids: [
                    ...state.ids,
                    ...action.response.id,
                ],
                loading: false,
            });

        case FETCH_POINT_OF_INTEREST_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                ids: [
                    ...state.ids,
                    ...action.payload.id,
                ],
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.payload.id]: reducerHelper.formatLocalisations(action.response.results),
                }),
            });

        case CREATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS:
        case UPDATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    [action.response.id]: Object.assign({}, action.response, action.payload.formValues.base),
                }),
                loading: false,
                localisation: Object.assign({}, state.localisation, {
                    [action.response.id]: action.payload.formValues.localisation,
                }),
            });

        case DELETE_POINT_OF_INTEREST_SUCCESS:
            const {
                id,
            } = action.payload;

            const deletedData = reducerHelper.removeItemFromObject(state.data, id);
            const deletedLocalisation = reducerHelper.removeItemFromObject(state.localisation, id);
            const deletedStateIds = reducerHelper.removeItemFromArrayOfStrings(state.ids, id);

            return Object.assign({}, state, {
                data: deletedData,
                ids: deletedStateIds,
                loading: false,
                localisation: deletedLocalisation,
                total: state.total - 1,
            });

        case POINTS_OF_INTEREST_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case POINTS_OF_INTEREST_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case POINTS_OF_INTEREST_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                order: action.payload.order,
            });

        case POINTS_OF_INTEREST_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/pointsofinterestReducer.js